import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myTimesheetCurrentRoleState = atom({
  key: "mySheetCurrentRole",
  default: "examiner",
  effects_UNSTABLE: [ocPersistAtom],
});

export default myTimesheetCurrentRoleState;
